import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Zap } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const TechQuickClose = ({ orderId, busy, onConfirm }) => {
  const [d, setD] = useState(null);
  const [pre, setPre] = useState(null);
  const key = `quick-close:${orderId}`;
  useEffect(() => {
    api.get(`/tech/orders/${orderId}/quick-close`).then((r) => { setPre(r.data); localStorage.setItem(key, JSON.stringify(r.data)); })
      .catch(() => setPre(JSON.parse(localStorage.getItem(key) || "null")));
  }, [orderId, key]);
  const open = async () => {
    try {
      const data = pre || (await api.get(`/tech/orders/${orderId}/quick-close`)).data;
      if (!data.reason || !data.service) return toast.error("Nessuna causale o prestazione abituale: compila il rapportino sotto");
      setD(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <>
      <Button onClick={open} disabled={busy} className="mb-4 h-14 w-full bg-emerald-600 text-base hover:bg-emerald-700" data-testid="tech-quick-close-button">
        <Zap className="mr-2 h-5 w-5" />Chiusura rapida · Ripristinato
      </Button>
      <AlertDialog open={!!d} onOpenChange={(o) => !o && setD(null)}>
        <AlertDialogContent data-testid="tech-quick-close-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Chiudere il guasto come ripristinato?</AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-2 text-sm">
                <div><span className="micro-label block">Causale</span><span data-testid="tech-quick-close-reason">{d?.reason.code} — {d?.reason.description}</span></div>
                <div><span className="micro-label block">Prestazione</span><span data-testid="tech-quick-close-service">{d?.service.code} — {d?.service.description}</span></div>
                <p className="text-xs">Foto, note e materiali inseriti qui sotto vengono inviati insieme.</p>
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="tech-quick-close-cancel">Annulla</AlertDialogCancel>
            <AlertDialogAction className="bg-emerald-600 hover:bg-emerald-700" onClick={() => onConfirm({ outcome: d.outcome, reason_code: d.reason.code, services: [{ code: d.service.code, qty: 1 }] })} data-testid="tech-quick-close-confirm">Chiudi intervento</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
